import {
  DocumentNode,
  MutationHookOptions,
  OperationVariables,
  TypedDocumentNode,
  useMutation,
} from "@apollo/client";

import { parseErrors } from "../graphql";
import { useSnackbarMessage } from "./useSnackbarMessage";

function useSnackbarMutation<T = any>(
  mutation: DocumentNode | TypedDocumentNode<any, OperationVariables>,
  opts: MutationHookOptions = {}
) {
  const { raiseErrorSnackbar } = useSnackbarMessage();

  return useMutation<T>(mutation, {
    fetchPolicy: "no-cache",
    onError: (e) => {
      raiseErrorSnackbar(parseErrors(e));
    },
    ...opts,
  });
}

export { useSnackbarMutation };
